export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const PROMOTION_DATA_SUCCESS = 'PROMOTION_DATA_SUCCESS';
export const PROMO_FINANCE_COST_DATA_SUCCESS =
  'PROMO_FINANCE_COST_DATA_SUCCESS';
export const FINANCE_TERM_SPLIT_DATA_SUCCESS = 'FINANCE_TERM_SPLIT_DATA_SUCCESS';
export const FINANCE_GROUP_RATES_DATA_SUCCESS = 'FINANCE_GROUP_RATES_DATA_SUCCESS';
export const PROMO_TERRITORY_DATA_SUCCESS = 'PROMO_TERRITORY_DATA_SUCCESS';
export const PROMO_TERRITORY_FORMAT_SUCCESS = 'PROMO_TERRITORY_FORMAT_SUCCESS';
export const PROMO_TERRITORY_FORMAT_BY_ID_SUCCESS =
  'PROMO_TERRITORY_FORMAT_BY_ID_SUCCESS';
export const PROMO_TERRITORY_FORMAT_FIELDS_SUCCESS =
  'PROMO_TERRITORY_FORMAT_FIELDS_SUCCESS';
export const PROMO_TERRITORY_UPLOAD_SUCCESS = 'PROMO_TERRITORY_UPLOAD_SUCCESS';
export const PROMO_FINANCE_COST_DETAIL_SUCCESS =
  'PROMO_FINANCE_COST_DETAIL_SUCCESS';
export const PROMO_FINANCE_TERM_SPLIT_DETAIL_SUCCESS =
  'PROMO_FINANCE_TERM_SPLIT_DETAIL_SUCCESS';
export const PROMO_FINANCE_GROUP_RATES_DETAIL_SUCCESS =
  'PROMO_FINANCE_GROUP_RATES_DETAIL_SUCCESS';
export const FINANCE_COST_FORMAT_SUCCESS = 'FINANCE_COST_FORMAT_SUCCESS';
export const FINANCE_TERM_SPLIT_FORMAT_SUCCESS = 'FINANCE_TERM_SPLIT_FORMAT_SUCCESS';
export const FINANCE_GROUP_RATE_FORMAT_SUCCESS = 'FINANCE_GROUP_RATE_FORMAT_SUCCESS';
export const FINANCE_COST_FORMAT_BY_ID_SUCCESS =
  'FINANCE_COST_FORMAT_BY_ID_SUCCESS';
export const FINANCE_COST_FORMAT_FIELDS_SUCCESS =
  'FINANCE_COST_FORMAT_FIELDS_SUCCESS';
export const FINANCE_TERM_SPLIT_FORMAT_FIELDS_SUCCESS = 'FINANCE_TERM_SPLIT_FORMAT_FIELDS_SUCCESS';
export const FINANCE_GROUP_RATES_FORMAT_FIELDS_SUCCESS = 'FINANCE_GROUP_RATES_FORMAT_FIELDS_SUCCESS';
export const PROMO_FINANCE_COST_UPLOAD_SUCCESS =
  'PROMO_FINANCE_COST_UPLOAD_SUCCESS';
export const PROMO_FINANCE_TERM_SPLIT_UPLOAD_SUCCESS =
  'PROMO_FINANCE_TERM_SPLIT_UPLOAD_SUCCESS';
export const PROMO_FINANCE_GROUP_RATE_UPLOAD_SUCCESS =
  'PROMO_FINANCE_GROUP_RATE_UPLOAD_SUCCESS';
export const COUNTRY_SUCCESS = 'COUNTRY_SUCCESS';
export const PROMO_MAP_SUCCESS = 'PROMO_MAP_SUCCESS';
export const PROMO_MAP_SINGLE_SUCCESS = 'PROMO_MAP_SINGLE_SUCCESS';
export const PROMO_MAPPING_FORMAT_SUCCESS = 'PROMO_MAPPING_FORMAT_SUCCESS';
export const PROMO_MAP_FORMAT_BY_ID = 'PROMO_MAP_FORMAT_BY_ID';
export const PROMO_MAP_FORMAT_FIELDS = 'PROMO_MAP_FORMAT_FIELDS';
export const PROMO_TYPES = 'PROMO_TYPES';
export const PROMO_STICKERS = 'PROMO_STICKERS';
export const PROMO_STICKER_BY_ID = 'PROMO_STICKER_BY_ID';
export const CLEAR_PROMO_STICKER_BY_ID = 'CLEAR_PROMO_STICKER_BY_ID';
export const MARKET_FILTERS = 'MARKET_FILTERS';
export const PROMO_FILTERS = 'PROMO_FILTERS';
export const MODEL_GROUP = 'MODEL_GROUP';
export const LOCATION_GROUP = 'LOCATION_GROUP';
export const MODEL_LIST_GROUP = 'MODEL_LIST_GROUP';
export const PROMO_CONFIG_UPLOAD_SUCCESS = 'PROMO_CONFIG_UPLOAD_SUCCESS';
export const PROMO_CONFIG_FORMAT_FIELDS_SUCCESS =
  'PROMO_CONFIG_FORMAT_FIELDS_SUCCESS';
export const PROMO_CONFIG_FORMAT_SUCCESS = 'PROMO_CONFIG_FORMAT_SUCCESS';
export const MATERIAL_PRICING_UPLOAD_SUCCESS =
  'MATERIAL_PRICING_UPLOAD_SUCCESS';
export const MATERIAL_PRICING_FORMAT_FIELDS_SUCCESS =
  'MATERIAL_PRICING_FORMAT_FIELDS_SUCCESS';
export const MATERIAL_PRICING_FORMAT_SUCCESS =
  'MATERIAL_PRICING_FORMAT_SUCCESS';
export const MATERIAL_PRICING_DATA_SUCCESS = 'MATERIAL_PRICING_DATA_SUCCESS';
export const MATERIAL_PRICING_SINGLE_DATA_SUCCESS =
  'MATERIAL_PRICING_SINGLE_DATA_SUCCESS';
export const PROMO_CONFIG_SINGLE_DATA_SUCCESS =
  'PROMO_CONFIG_SINGLE_DATA_SUCCESS';
export const SCENARIO_LIST_DATA_SUCCESS = 'SCENARIO_LIST_DATA_SUCCESS';
export const SAND_BOX_DATA_SUCCESS = 'SAND_BOX_DATA_SUCCESS';
export const HISTORY_DATA_SUCCESS = 'HISTORY_DATA_SUCCESS';
export const PROMOTIONS_SEARCH_SUCCESS = 'PROMOTIONS_SEARCH_SUCCESS';
export const COSTING_START = 'COSTING_START';
export const COSTING_END = 'COSTING_END';
export const PROMO_CONFIG_DATA_SUCCESS = 'PROMO_CONFIG_DATA_SUCCESS';
export const PREFILL_SCENARIO_SUCCESS = 'PREFILL_SCENARIO_SUCCESS';
export const SCENARIO_BY_ID = 'SCENARIO_BY_ID';
export const COVERAGE_MAPPING_UPLOAD_SUCCESS =
  'COVERAGE_MAPPING_UPLOAD_SUCCESS';
export const COVERAGE_MAPPING_FORMAT_FIELDS_SUCCESS =
  'COVERAGE_MAPPING_FORMAT_FIELDS_SUCCESS';
export const COVERAGE_MAPPING_FORMAT_SUCCESS =
  'COVERAGE_MAPPING_FORMAT_SUCCESS';
export const COVERAGE_MAPPING_DATA_SUCCESS = 'COVERAGE_MAPPING_DATA_SUCCESS';
export const COVERAGE_MAPPING_SINGLE_SUCCESS =
  'COVERAGE_MAPPING_SINGLE_SUCCESS';
export const STANDARD_FINANCE_UPLOAD_SUCCESS =
  'STANDARD_FINANCE_UPLOAD_SUCCESS';
export const STANDARD_FINANCE_FORMAT_FIELDS_SUCCESS =
  'STANDARD_FINANCE_FORMAT_FIELDS_SUCCESS';
export const STANDARD_FINANCE_FORMAT_SUCCESS =
  'STANDARD_FINANCE_FORMAT_SUCCESS';
export const STANDARD_FINANCE_DATA_SUCCESS = 'STANDARD_FINANCE_DATA_SUCCESS';
export const STANDARD_FINANCE_SINGLE_DATA_SUCCESS =
  'STANDARD_FINANCE_SINGLE_DATA_SUCCESS';
export const PROMOTION_CURRENCY_UPLOAD_SUCCESS =
  'PROMOTION_CURRENCY_UPLOAD_SUCCESS';
export const PROMOTION_CURRENCY_FORMAT_FIELDS_SUCCESS =
  'PROMOTION_CURRENCY_FORMAT_FIELDS_SUCCESS';
export const PROMOTION_CURRENCY_FORMAT_SUCCESS =
  'PROMOTION_CURRENCY_FORMAT_SUCCESS';
export const PROMOTION_CURRENCY_DATA_SUCCESS =
  'PROMOTION_CURRENCY_DATA_SUCCESS';
export const PROMOTION_CURRENCY_SINGLE_SUCCESS =
  'PROMOTION_CURRENCY_SINGLE_SUCCESS';
export const TERRITORY_ID_SUCCESS = 'TERRITORY_ID_SUCCESS';
export const SAVED_SCENARIO = 'SAVED_SCENARIO';
export const SALES_FORECAST_SINGLE_DATA_SUCCESS =
  ' SALES_FORECAST_SINGLE_DATA_SUCCESS';
export const SCENARIO_MARKETS = 'SCENARIO_MARKETS';
export const PREVIOUS_SCENARIO = 'PREVIOUS_SCENARIO';
export const REVIEW_SCENARIO = 'REVIEW_SCENARIO';
export const CURRENT_SCENARIO = 'CURRENT_SCENARIO';
export const TR_APPROVAL_DATA_SUCCESS = 'TR_APPROVAL_DATA_SUCCESS';
export const MULTI_PROMO_SEARCH_SUCCESS = 'MULTI_PROMO_SEARCH_SUCCESS';
export const TR_APPROVAL_REVIEW_DATA_SUCCESS =
  'TR_APPROVAL_REVIEW_DATA_SUCCESS';
export const TR_APPROVAL_REVIEW_COMPLETED_DATA_SUCCESS =
  'TR_APPROVAL_REVIEW_COMPLETED_DATA_SUCCESS';
export const MARKET_START = 'MARKET_START';
export const MARKET_END = 'MARKET_END';
export const CUSTOM_GROUP_ID = 'CUSTOM_GROUP_ID';
export const CUSTOM_GROUPS = 'CUSTOM_GROUPS';
export const CUSTOM_GROUP_LIST = 'CUSTOM_GROUP_LIST';
export const GROUPED_CUSTOM_GROUP = 'GROUPED_CUSTOM_GROUP';
export const PROMOTION_COSTING_COMPARISON_UPLOAD_SUCCESS =
  'PROMOTION_COSTING_COMPARISON_UPLOAD_SUCCESS';
export const PROMO_COSTING_DROPDOWN_DATA_SUCCESS =
  'PROMO_COSTING_DROPDOWN_DATA_SUCCESS';
export const ARCHIVE = 'ARCHIVE';
export const STICKER_ARCHIVE = 'STICKER_ARCHIVE';
export const PROMO_COSTING_TABLE_DATA_SUCCESS =
  'PROMO_COSTING_TABLE_DATA_SUCCESS';
export const LOCATION_FILTER = 'LOCATION_FILTER';
export const SCENARIO_DATA = 'SCENARIO_DATA';
export const GRID_DATA = 'GRID_DATA';
export const USER_ACCESS_DATA = 'USER_ACCESS_DATA';
export const CURRENT_MODEL_YEAR = 'CURRENT_MODEL_YEAR';
export const CLEAR_DATA = 'CLEAR_DATA';
export const PROMO_FINANCE_COSTING_DIALOG_DATA_SUCCESS =
  'PROMO_FINANCE_COSTING_DIALOG_DATA_SUCCESS';
export const PROMO_PROMOTIONAL_OFFERS_DATA_SUCCESS =
  'PROMO_PROMOTIONAL_OFFERS_DATA_SUCCESS';
export const PROMO_REGULAR_OFFERS_DATA_SUCCESS =
  'PROMO_REGULAR_OFFERS_DATA_SUCCESS';
export const PROMO_REGULAR_OFFERS_UPLOAD_SUCCESS =
  'PROMO_REGULAR_OFFERS_UPLOAD_SUCCESS';
export const PROMO_REGULAR_OFFERS_FORMAT_SUCCESS =
  'PROMO_REGULAR_OFFERS_FORMAT_SUCCESS';
export const PROMO_REGULAR_OFFERS_FIELDS_SUCCESS =
  'PROMO_REGULAR_OFFERS_FIELDS_SUCCESS';
export const PROMO_REGULAR_FINANCING_DATA_SUCCESS =
  'PROMO_REGULAR_FINANCING_DATA_SUCCESS';
export const DOWNLOADING = 'DOWNLOADING';
export const VALID_MARKETS = 'VALID_MARKETS';
export const PROMO_COMMENT_DIALOG_DATA_SUCCESS = 'PROMO_COMMENT_DIALOG_DATA_SUCCESS';
export const HISTORY_UPLOAD_SUCCESS = 'HISTORY_UPLOAD_SUCCESS';
export const MANUAL_PROMO_SUCCESS = 'MANUAL_PROMO_SUCCESS';
export const MANUAL_FIELD_SUCCESS = 'MANUAL_FIELD_SUCCESS';
export const MANUAL_UPLOAD_FORMAT_DATA = 'MANUAL_UPLOAD_FORMAT_DATA';
export const MANUAL_UPLOAD_FORMAT_UPDATE_OR_DELETE = 'MANUAL_UPLOAD_FORMAT_UPDATE_OR_DELETE';
export const MANUAL_PROMO_BY_ID = 'MANUAL_PROMO_BY_ID';
export const PROMO_COSTING_ANALYSIS_DATA_SUCCESS = 'PROMO_COSTING_ANALYSIS_DATA_SUCCESS';
export const PROMO_FIN_EXCEPTION_SCENARIO_SUCCESS = 'PROMO_FIN_EXCEPTION_SCENARIO_SUCCESS';
export const PROMO_BUDGET_DATA_SUCCESS = 'PROMO_BUDGET_DATA_SUCCESS';
export const TEMP_PROMO_BUDGET_DATA_SUCCESS = 'TEMP_PROMO_BUDGET_DATA_SUCCESS';
export const BUDGET_LIST_DATA_SUCCESS = 'BUDGET_LIST_DATA_SUCCESS';
export const PROMO_BUDGET_PREFILL_DATA_SUCCESS = 'PROMO_BUDGET_PREFILL_DATA_SUCCESS';
export const BUDGET_PREFILL_LIST_DATA_SUCCESS = 'BUDGET_PREFILL_LIST_DATA_SUCCESS';
export const BUDGET_STICKER_CLONED_DATA = 'BUDGET_STICKER_CLONED_DATA';
export const BUDGET_VOLUME_DATA_SUCCESS = 'BUDGET_VOLUME_DATA_SUCCESS';
export const BUDGET_SALES_FORECAST_DATA_SUCCESS = 'BUDGET_SALES_FORECAST_DATA_SUCCESS';
export const BUDGET_SALES_FORECAST_SINGLE_DATA_SUCCESS = 'BUDGET_SALES_FORECAST_SINGLE_DATA_SUCCESS';
export const BUDGET_REPORTING_DATA_SUCCESS = 'BUDGET_REPORTING_DATA_SUCCESS';
export const APPROVED_SCENARIO_LIST_SUCCESS = 'APPROVED_SCENARIO_LIST_SUCCESS';
export const PROMO_SIGNATURE_CONFIG_LIST_SUCCESS = 'PROMO_SIGNATURE_CONFIG_LIST_SUCCESS';
export const PROMO_SIGNATURE_CONFIG_BY_ID_SUCCESS = 'PROMO_SIGNATURE_CONFIG_BY_ID_SUCCESS';
export const PROMO_MATERIAL_MASTER_DETAIL_SUCCESS = 'PROMO_MATERIAL_MASTER_DETAIL_SUCCESS';
